module.exports = __webpack_public_path__ + "static/media/griechischesbad.4c6550d0.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Sizilien/griechischesbad.JPG
// module id = 767
// module chunks = 0